import router from '@/router';
import { PermissionPageKey } from '@/types/permission';
import { tokenManager } from './security/token-manager';

export default {
  getUToken() {
    return tokenManager.getToken();
  },

  rmUToken() {
    return tokenManager.removeToken();
  },

  setUToken(token: string, expiresInSeconds?: number) {
    tokenManager.setToken(token, expiresInSeconds);
  },

  goToHomePage() {
    window.location.href = '/#/';
  },
  goToProductionConfig() {
    router.push({ name: PermissionPageKey.ProjectSettingTR });
  },

  goToLoginPage(redirectToCurrent?: boolean) {
    if (router.currentRoute.value.path === '/login') {
      return;
    }
    if (redirectToCurrent) {
      const redirect = window.location.hash.replace(/^#/, '');
      window.location.href = `#/login?redirect=${redirect}`;
      return;
    }
    window.location.href = '#/login';
  },

  goTo404Page() {
    router.push('/404');
  },

  goTo403Page() {
    router.push('/403');
  },

  /**
   * @description 获取用户头像 url
   */
  getAvatarUrl(avatar?: string) {
    return avatar || 'https://res-cn.makeblock.com/passport/official/avatar/1.png';
  },

  /**
   * @description 是否移动端
   */
  isMobile() {
    if (
      navigator.userAgent.match(/Mobi/i) ||
      navigator.userAgent.match(/Android/i) ||
      navigator.userAgent.match(/iPhone/i)
    ) {
      // 当前设备是移动设备
      return true;
    }
    return false;
  },
};
